package com.upcominds.expedite.data.leaders

import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.model.CommunityLeader
import com.upcominds.expedite.model.Leader
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter

class LeadersRepositoryImpl: LeadersRepository {

    private val httpClient: HttpClient = NetworkClient.httpClient


    override suspend fun getGlobal(page: Int, size: Int): List<Leader> {
        return httpClient.get(NetworkClient.endpoint("api/leaders/global")) {
            parameter("page", page)
            parameter("size", size)
        }.body<List<Leader>>()
    }

    override suspend fun getCurrentUserGlobalLeader(): Leader? {
        return httpClient.get(NetworkClient.endpoint("api/leaders/global/me"))
            .body<Leader?>()
    }

    override suspend fun getCommunity(communityId: String, page: Int, size: Int): List<Leader> {
        return httpClient.get(NetworkClient.endpoint("api/leaders/community/${communityId}")) {
            parameter("page", page)
            parameter("size", size)
        }.body<List<Leader>>()
    }

    override suspend fun getUserCommunitiesLeaders(page: Int, size: Int): List<CommunityLeader> {
        return httpClient.get(NetworkClient.endpoint("api/leaders/me")) {
            parameter("page", page)
            parameter("size", size)
        }.body<List<CommunityLeader>>()
    }
}
